import {LocationState, push, replace} from '@web/slices/router'

type NavigateToRouteParams = {
    /** 페이지 이동 시 히스토리 쌓는 방식 */
    historyType: 'PUSH' | 'REPLACE'
    /** 대상 Route Path */
    path: string
    /** Route State 에 반영할 부가 상태 값 */
    state?: LocationState
    resetScroll?: boolean
}

/**
 * App 내부 Route 로 이동하는 액션
 * - navigate-to 라이브러리 내부 전용 액션
 * - ⚠️ export 금지
 *
 * @private
 */
const navigateToRoute = ({historyType, path, state, resetScroll}: NavigateToRouteParams) =>
    (historyType === 'REPLACE' ? replace : push)(path, {state, resetScroll})

export default navigateToRoute
